
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

// Components

import AttributeView from './AttributeView';


const ManageAttributes = props => {

    const ATTRIBUTES = {
        TAGS: 'tags',
        WORKGROUPS: 'workgroups',
    };

    const MODES = {
        EDIT: 'EDIT',
        READONLY: 'READONLY'
    };

    const [ views, toggleViews ] = useState({
        [ ATTRIBUTES.TAGS ]: MODES.READONLY,
        [ ATTRIBUTES.WORKGROUPS ]: MODES.READONLY
    });

    const {
        assignees,
        changeCurrentAssignee,
        currentAssignee = {},
        currentAssignee: {
            id: userId,
            name
        } = { },
        lists,
        updateAssignees,
        updateAssigneeAttributes
    } = props;

    const changeMode = updatedMode => {
        toggleViews(views => ({
            ...views,
            ...updatedMode
        }));
    };

    const handleBackClick = () => {
        changeCurrentAssignee(null);
    };

    const getViews = () => {
        return Object.entries(views).map(([ view, mode ]) => {
            return (
                <AttributeView
                    key = { view }
                    { ...{
                        assignees,
                        attributeTypes: ATTRIBUTES,
                        attributes: currentAssignee[view],
                        changeMode,
                        currentAssignee,
                        lists,
                        mode,
                        modes: MODES,
                        updateAssignees,
                        updateAssigneeAttributes,
                        userId,
                        view,
                        views
                    } }
                />
            );
        });
    };

    return (
        <div className = 'assignee-section gi-panel'>
            <span className="usa-width-one-whole back-to-dashboard">
                <a
                    className="usa-width-one-whole border-link cursor-pointer"
                    href = { undefined }
                    onClick = { handleBackClick }
                >
                    <FontAwesomeIcon icon="caret-left" size="1x" className="icon-link"/>
                    <FormattedMessage id = 'assignees.link.back_to_results'/>
                </a>
            </span>
            <h3 className = 'margin-top-1em margin-bottom-1em'>
                { name }
            </h3>
            { getViews() }
        </div>
    );
};

export default ManageAttributes;